// A phone's width: room for a comfortable bubble, and for three chats beside
// the list on a 1920px screen.
export const CHAT_COLUMN_WIDTH = 380;

// The chat list; narrow enough that two fit when both lists are shown.
export const CHAT_LIST_WIDTH = 280;

// Bubbles stop growing here however wide their pane is, so long lines stay
// readable in the wide supplier and overview panes too.
export const BUBBLE_MAX_WIDTH = 340;

// Photos, videos and stickers never take more than this share of their
// thread's visible height (laptop screens), and never shrink below the floor.
export const MEDIA_MAX_THREAD_SHARE = 0.6;
export const MEDIA_MIN_HEIGHT = 140;
export const CHAT_THREAD_VIEWPORT = "[data-chat-thread-viewport]";

export { MAX_CHAT_COLUMNS, CHAT_COLUMN_COLORS } from "../../models/chat/chatColumnsModel";

// An unfocused column's colour: the same hue, faded.
export const fadedColumnColor = color => `${color}59`;
